import { IconButton, InputAdornment, TextField, TextFieldProps } from '@ha/dsl';
import { Delete2Light } from '@ha/icons';
import React from 'react';

interface OwnProps {
  dateValue: string;
  onClear?: () => void;
  onInputClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export type Props = OwnProps & TextFieldProps;

const DateInput: React.FC<Props> = props => {
  const {
    dateValue,
    onClear,
    onInputClick,
    disabled = false,
    focused = false,
    ...rest
  } = props;

  const onClearButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      if (onClear) {
        onClear();
      }
      event.stopPropagation();
    },
    [onClear],
  );

  const inputProps = {
    'data-test-locator': props['data-test-locator']
      ? `${props['data-test-locator']} / Input`
      : '',
  };

  const clearButtonLocator = props['data-test-locator']
    ? `${props['data-test-locator']} / Clear Button`
    : '';

  const Adornment = (
    <InputAdornment position="end">
      <IconButton
        edge="end"
        disabled={disabled}
        onClick={disabled ? undefined : onClearButtonClick}
        data-test-locator={clearButtonLocator}
      >
        <Delete2Light fontSize="small" />
      </IconButton>
    </InputAdornment>
  );

  return (
    <TextField
      fullWidth
      value={dateValue}
      disabled={disabled}
      InputProps={{
        readOnly: true,
        endAdornment: onClear ? Adornment : null,
      }}
      inputProps={inputProps}
      onClick={disabled ? undefined : onInputClick}
      focused={focused}
      {...rest}
    />
  );
};

export default DateInput;
